import { createSelector } from 'reselect';
import { filter } from 'ramda';
import { getFormValues } from 'redux-form';

import { filterByString } from '@topconagriculture/frontend-utils';

import { RootState } from '../../reducers';
import { GroupType } from './groupType.types';
import { Forms } from '../../form/form.selector';
import { getCodeListFilteredByType } from '../code/code.selector';
import { CodeElement, CodeTypeNames } from '../code/code.types';

export const getGroupTypeList = (state: RootState): GroupType[] => state.entities.groupType || [];

export const getGroupTypesListFilteredBySearch = createSelector(
  [getGroupTypeList, getFormValues(Forms.penTypesSearch)],
  (groupTypesList, filterForm: any): GroupType[] =>
    filterForm && filterForm.search
      ? filter(
          (groupType) =>
            filterByString(groupType.description, filterForm.search) ||
            filterByString(groupType.groupClassCode.toString(), filterForm.search) ||
            filterByString(groupType.id.toString(), filterForm.search),
          groupTypesList,
        )
      : groupTypesList,
);

const getGroupClasses = (state: RootState): CodeElement[] =>
  getCodeListFilteredByType(state, { codeType: CodeTypeNames.groupClassCodes });

export const getGroupClassDescriptionByCode = createSelector(
  [getGroupClasses, (state: RootState, code: number) => code],
  (groupClasses, code): string | undefined => {
    const groupClass = groupClasses.find((el) => el.code === code);
    return groupClass ? groupClass.description1 : undefined;
  },
);

export const getGroupTypeById = createSelector(
  getGroupTypeList,
  (groupTypes) => (id: string) => groupTypes.find((type) => type.id === id),
);
